import {request} from "./request";

//course
export function GetCourseStuListLikeKeyByPage(cid, key, page) {
  return request({
    url: 'student/GetCourseStuListLikeKeyByPage',
    params: {
      cid,
      key,
      page
    }
  })
}

export function GetCourseStuListCountByKey(cid, key) {
  return request({
    url: 'student/GetCourseStuListCountByKey',
    params: {
      cid,
      key
    }
  })
}

export function delStuInStuSelect(stunum) {
  return request({
    url: 'student/DelStuInStuSelect',
    params: {
      stunum
    }
  })
}


//club
export function GetClubStuListLikeKeyByPage(cid, key, page) {
  return request({
    url: 'student/GetClubStuListLikeKeyByPage',
    params: {
      cid,
      key,
      page
    }
  })
}

export function GetClubStuListCountByKey(cid, key) {
  return request({
    url: 'student/GetClubStuListCountByKey',
    params: {
      cid,
      key
    }
  })
}

export function DelStuInClubSelect(sid) {
  return request({
    url: 'student/DelStuInClubSelect',
    params: {
      sid
    }
  })
}

export function ModifyStuRankInClubSelect(sid, ranks) {
  return request({
    url: 'student/ModifyStuRankInClubSelect',
    params: {
      sid, ranks
    }
  })
}

export function ModifyStuETimeInClubSelect(sid, etime) {
  return request({
    url: 'student/ModifyStuETimeInClubSelect',
    params: {
      sid, etime
    }
  })
}

//venue
export function GetVenueStuListLikeKeyByPage(id, key, page) {
  return request({
    url: 'student/GetVenueStuListLikeKeyByPage',
    params: {
      id,
      key,
      page
    }
  })
}

export function DelStuInVenueSelect(sid, years, months, days) {
  return request({
    url: 'student/DelStuInVenueSelect',
    params: {
      sid, years, months, days
    }
  })
}

export function GetVenueStuListCountByKey(cid, key) {
  return request({
    url: 'student/GetVenueStuListCountByKey',
    params: {
      cid,
      key
    }
  })
}

//venue
export function GetPhyTestStuListLikeKeyByPage(id, key, page) {
  return request({
    url: 'PhyTest/GetPhyTestStuListLikeKeyByPage',
    params: {
      id,
      key,
      page
    }
  })
}

export function DelStuInPhyTestSelect(sid, years, months, days) {
  return request({
    url: 'PhyTest/DelStuInPhyTestSelect',
    params: {
      sid, years, months, days
    }
  })
}

export function GetPhyTestStuListCountByKey(pid, key) {
  return request({
    url: 'PhyTest/GetPhyTestStuListCountByKey',
    params: {
      pid,
      key
    }
  })
}

